import React from 'react';
import { useDispatch } from 'react-redux';
import { deleteFavOrder } from '@kfc-global/react-shared/redux/Actions/OrderHistoryAction';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ModalComponent from 'molecules/Modal';
import ImageComponent from 'atoms/Image';
import { toastifyFnWithImage } from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import RemoveFavModal from '../../Presentation/FavoriteOrders/RemoveFavModal';

const RemoveFavouriteOrder = props => {
  const { item, setIsModalOpen, tenantId, customerId, currentItemId } = props;
  const dispatch = useDispatch();

  const imageTemp = <ImageComponent srcFile={IMAGE_PATH.FavoriteInActiveWhite} />;
  const removeToastMsg = translateWithI18Next(TRANSLATE_MAPPING_KEY.REMOVED_FROM_FAVORDERS);

  const closeModel = () => {
    setIsModalOpen(false);
  };

  const modalProps = {
    id: 'removeFromFavOrders',
    role: 'dialog',
    modalTitleId: 'FavouriteOrdersRemove',
    show: true,
    classNames: 'test',
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: closeModel,
    modalTitle: '',
    modalTitleRequired: false,
    closeDataTestId: 'close-modal',
    autoFocus: true,
  };

  const deleteTheOccassion = async (tenant_id, customer_id, itemId) => {
  await dispatch(
      deleteFavOrder({
        tenantId: tenant_id,
        customerId: customer_id,
        itemId,
      }),
    );
  };

  const onRemoveHandler = event => {
    const accordian = event.target?.parentElement?.parentElement?.parentElement;
    if (accordian?.classList.contains('account-accordian-open')) {
      accordian?.classList.remove('account-accordian-open');
    }
    setIsModalOpen(false);
    deleteTheOccassion(tenantId, customerId, currentItemId);
    toastifyFnWithImage(removeToastMsg, imageTemp, 'favorites-added-toast');
  };

  return (
    <div>
      <ModalComponent {...modalProps}>
        <RemoveFavModal
          onCancelHandler={closeModel}
          setIsModalOpen={setIsModalOpen}
          onRemoveHandler={onRemoveHandler}
          item={item}
          data-testid='remove-modal'
        />
      </ModalComponent>
    </div>
  );
};

export default RemoveFavouriteOrder;
